import type { CSSProperties } from 'react'

interface DividerProps {
  style?: CSSProperties
}

export function Divider({ style }: DividerProps) {
  return <div style={{ height: 1, background: 'var(--border-subtle)', ...style }} />
}
